import Sortable from './sortable.complete.esm.js';

const sortableLists = new Map();

window.createSortableList = function(options) {
    const {
        listElementReference,
        blazorComponent,
        onUpdateCallbackName,
        onRemoveCallbackName,
        groupClassName,
        groupCloneOnDrop,
        groupDropEnabled,
        filterClassName,
        isEnabled,
        forceFallback,
        dragHandleClassName
    } = options;

    const sortable = new Sortable(
        listElementReference, 
        {
            animation: 200,
            group: {
                name: groupClassName,
                pull: groupCloneOnDrop ? 'clone' : true,
                put: groupDropEnabled
            },
            filter: filterClassName || undefined,
            sort: isEnabled,
            forceFallback: forceFallback,
            handle: dragHandleClassName || undefined,
            onStart: () => {
                document.body.style.cursor = 'grabbing';
            },
            onEnd: () => {
                document.body.style.cursor = 'default';
            },
            onUpdate: (event) => {
                event.item.remove();
                event.to.insertBefore(event.item, event.to.childNodes[event.oldIndex]);
    
                if (onUpdateCallbackName === null) {
                    console.log('Specify a callback for list updates');
                    return;
                }
                
                blazorComponent.invokeMethodAsync(onUpdateCallbackName, event.oldDraggableIndex, event.newDraggableIndex);
            },
            onRemove: (event) => {
                if (event.pullMode === 'clone') {
                    event.clone.remove();
                }
    
                event.item.remove();
                event.from.insertBefore(event.item, event.from.childNodes[event.oldIndex]);
    
                if (onRemoveCallbackName === null) {
                    console.log('Specify a callback for removals from the list');
                    return;
                }
                
                blazorComponent.invokeMethodAsync(onRemoveCallbackName, event.oldDraggableIndex, event.newDraggableIndex);
            }
        }
    );
    
    const sortableListId = crypto.randomUUID();
    sortableLists.set(sortableListId, sortable);
    return sortableListId;
}


window.disposeSortableList =  function (id) {
    const sortable = sortableLists.get(id);
    if (sortable) {
        sortable.destroy();
        sortableLists.delete(id);
    }
}